import { render, staticRenderFns } from "./SubgrupoProdutoForm.vue?vue&type=template&id=73a60bfd"
import script from "./SubgrupoProdutoForm.vue?vue&type=script&lang=js"
export * from "./SubgrupoProdutoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports